import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { RegionProvider } from "@/context/RegionContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import SavedJobs from "@/pages/SavedJobs";
import AdminDashboard from "@/pages/AdminDashboard";
import CareerAdvice from "@/pages/CareerAdvice";
import Employers from "@/pages/Employers";
import About from "@/pages/About";

function App() {
  return (
    <RegionProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/career-advice" element={<CareerAdvice />} />
            <Route path="/employers" element={<Employers />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/saved" element={<ProtectedRoute><SavedJobs /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </RegionProvider>
  );
}

export default App;
